export class CheckCorrectionRequest {
  public checkNumber: string
  public checkDate: Date
}
